<template>
  <div id="scroll-animate">
    <div id="scroll-animate-main">
      <div class="wrapper-parallax">
        <header>
          <img src="https://www.cidp.edu.cn/images/22/006.png" style="width: 100%;height: 800px;">
        </header>
        <section class="content">

          <div class="wave1"></div>
          <div class="wrapper">
            <i class="ali-iconfont icon-down" @click="scrollToMain"></i>
          </div>
          <div class="wave2"></div>

          <div class="briefInfo">
            <div class="titles brief">
              <i class="bookmark icon"></i>
              研发中心简介
            </div>
            <div class="grid-flex" v-for="blog in briefInfo" :key="blog.id" @click.prevent="toBlog(blog)">
              <div class="col col-image"
                   :style="{'background-image':'url(' + blog.firstPicture + ')'}">
              </div>
              <div class="col col-text" style="background-color: #FFFFFF">
                <div class="Aligner-item">
                  <p> {{ blog.description }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="teachers">
            <div class="titles">
              <i class="bookmark icon"></i>
               研发中心师资力量
            </div>
            <ul class="cards">
              <li class="cards__item" v-for="blog in homeTeacherList" :key="blog.id" @click.prevent="toBlog(blog)">
                <div class="card">
                  <div class="card__image" :style="{'background-image':'url(' + blog.firstPicture + ')'}"></div>
                  <div class="card__content">
                    <div class="card__title">{{ blog.title }}</div>
                    <p class="card__text">{{ blog.description }}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="recommendation" style="width: 100%;height: 300px;">
            <!--推荐文章-->
            <div class="ei segments m-box">
              <div class="ei secondary segment"><i class="bookmark icon"></i>智能推荐文章</div>
              <div class="ei yellow segment">
                <div class="ei divided items">
                  <div class="m-item" v-for="blog in recommendList" :key="blog.id" @click.prevent="toBlog(blog)">
                    <div class="img" :style="{'background-image':'url(' + blog.firstPicture + ')'}"></div>
                    <div class="info">
                      <div class="date">{{ blog.createTime | dateFormat('YYYY-MM-DD') }}</div>
                      <div class="title">{{ blog.title }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </section>
        <footer ref="footer">
          <div class="foot">
            <div class="w1200">
              <div class="Foot">
                <div class="syd"><a href=" " target="_blank">
                  <img src="../../../public/img/事业单位.png"></a>
                </div>
                <div>
                  <span>Copyright © 2024-防灾科技学院 ALL Rights Reserved</span> <br>
                  <span>地址：河北省三河市燕郊高新区学院街465号 &nbsp;邮编：065201<br></span>
                  <span><a href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
                           target="_self">我是备案号</a></span>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import Introduction from "@/components/sidebar/Introduction.vue";
import {getSite} from "@/api";
import {mapState} from "vuex";

export default {
  components: {Introduction},
  data() {
    return {
      briefInfo: [],
      homeTeacherList: [],
      recommendList: [],
    }
  },
  created() {
    this.getSite()
  },

  computed: {
    ...mapState(['clientSize'])
  },

  mounted() {
    const windowHeight = window.innerHeight;
    const footerHeight = this.$refs.footer.offsetHeight;
    const heightDocument = windowHeight + this.$el.querySelector('.content').offsetHeight + footerHeight - 120;

    document.getElementById('scroll-animate').style.height = heightDocument + 'px';
    document.getElementById('scroll-animate-main').style.height = heightDocument + 'px';

    document.querySelector('header').style.height = windowHeight + 'px';
    document.querySelector('header').style.lineHeight = windowHeight + 'px';

    document.querySelector('.wrapper-parallax').style.marginTop = windowHeight + 'px';

    window.addEventListener('scroll', this.handleScroll);
    this.scrollFooter(window.scrollY, footerHeight);

  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    getSite() {
      getSite().then(res => {
        if (res.code === 200) {
          console.log(res)
          this.briefInfo = res.data.briefInfo
          this.homeTeacherList = res.data.homeTeachersList
          this.recommendList = res.data.userRecommendations

        }
      })
    },
    toBlog(blog) {
      console.log(blog)
      this.$store.dispatch('goBlogPage', blog)
    },
    handleScroll() {
      const scroll = window.scrollY;
      const footerHeight = this.$refs.footer.offsetHeight;
      const heightDocument = window.innerHeight + this.$el.querySelector('.content').offsetHeight + footerHeight - 20;

      document.getElementById('scroll-animate-main').style.top = '-' + scroll + 'px';
      document.querySelector('header').style.backgroundPositionY = 50 - (scroll * 100 / heightDocument) + '%';

      this.scrollFooter(scroll, footerHeight);
    },
    scrollFooter(scrollY, heightFooter) {
      const footer = document.querySelector('footer');
      if (scrollY >= heightFooter) {
        footer.style.bottom = '0px';
      } else {
        footer.style.bottom = '-' + heightFooter + 'px';
      }
    },
    //平滑滚动至正文部分
    scrollToMain() {
      window.scrollTo({top: this.clientSize.clientHeight, behavior: 'smooth'})
    },
  }
};
</script>

<style>

#scroll-animate {
  overflow: hidden;
}

#scroll-animate-main {
  width: 100%;
  left: 0;
  position: fixed;
}

#heightPage,
#heightScroll {
  width: 10px;
  top: 0;
  position: absolute;
  z-index: 99;
}

#heightPage {
  left: 0;
}

#heightScroll {
  right: 0;
}

header {
  width: 100%;
  height: 100%;
  top: 0;
  position: fixed;
  z-index: -2;
}

.content {
  height: 2020px;
  background: #ededed;
  position: relative;
  z-index: 1;
}

.wave1, .wave2 {
  position: absolute;
  top: -74px;
  transition-duration: .4s, .4s;
  z-index: 80;
}

.wave1 {
  background: url('/img/header/wave1.png') repeat-x;
  height: 75px;
  width: 100%;
}

.wave2 {
  background: url('/img/header/wave2.png') repeat-x;
  height: 90px;
  width: calc(100% + 100px);
  left: -100px;
}

.wrapper {
  position: absolute;
  width: 100px;
  top: -100px;
  left: 0;
  right: 0;
  margin: auto;
  font-size: 26px;
  z-index: 100;
}

.wrapper i {
  font-size: 60px;
  opacity: 0.5;
  cursor: pointer;
  position: absolute;
  top: 55px;
  left: 20px;
  animation: opener .5s ease-in-out alternate infinite;
  transition: opacity .2s ease-in-out, transform .5s ease-in-out .2s;
}

.wrapper i:hover {
  opacity: 1;
}

@keyframes lineMove {
  9% {
    top: 38px;
  }
  14% {
    top: 8px;
  }
  18% {
    top: 42px;
  }
  22% {
    top: 1px;
  }
  32% {
    top: 32px;
  }
  34% {
    top: 12px;
  }
  40% {
    top: 26px;
  }
  43% {
    top: 7px;
  }
  99% {
    top: 30px;
  }
}

@keyframes malfunctionAni {
  10% {
    top: -0.4px;
    left: -1.1px;
  }
  20% {
    top: 0.4px;
    left: -0.2px;
  }
  30% {
    left: .5px;
  }
  40% {
    top: -0.3px;
    left: -0.7px;
  }
  50% {
    left: 0.2px;
  }
  60% {
    top: 1.8px;
    left: -1.2px;
  }
  70% {
    top: -1px;
    left: 0.1px;
  }
  80% {
    top: -0.4px;
    left: -0.9px;
  }
  90% {
    left: 1.2px;
  }
  100% {
    left: -1.2px;
  }
}

@keyframes opener {
  100% {
    top: 65px
  }
}


.wrapper-parallax {
  margin-top: 100%;
  margin-bottom: 300px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);
}

.titles {
  margin:0 0 1rem 0;
  display: flex;
  align-items: center;
  height: 50px;
  background-color: #FFFFFF;
  border-top: #fbbd08 2px solid;
}

.titles i{
  margin-left: 10px;
}

.titles.brief {
  margin-bottom: 0;
}

header,
footer,
#scroll-animate-main {
  -webkit-transition-property: all;
  -moz-transition-property: all;
  transition-property: all;
  -webkit-transition-duration: 0.4s;
  -moz-transition-duration: 0.4s;
  transition-duration: 0.4s;
  -webkit-transition-timing-function: cubic-bezier(0, 0, 0, 1);
  -moz-transition-timing-function: cubic-bezier(0, 0, 0, 1);
  transition-timing-function: cubic-bezier(0, 0, 0, 1);
}


.briefInfo {
  height: 580px;
  padding: 150px 0 150px 0;
}


.col-text {
  height: 20em;
}

.grid-flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  flex-direction: row;
  -webkit-flex-direction: row;
  -webkit-flex-wrap: wrap;
  -webkit-justify-content: space-around;
}

.col {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.col-left {
  -webkit-box-ordinal-group: -1;
  -webkit-order: -1;
  -ms-flex-order: -1;
  order: -1;
}

.col-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Aligner-item {
  width: 60%;
}

.Aligner-item p {
  font-size: 20px;
}

.col-image {
  background-size: cover;
  background-position: center center;
}

@media (max-width: 640px) {
  .grid-flex {
    height: 40em;
    display: -webkit-flex;
    -webkit-flex-direction: column;
    flex-direction: column;
  }

  .col {
    order: vertical;
  }

  .col-left {
    -webkit-box-ordinal-group: 0;
    -webkit-order: 0;
    -ms-flex-order: 0;
    order: 0;
  }

  .col-text div p {
    padding: 1em;
    font-size: 20px;
  }

  .Aligner-item {
    width: 90%;
  }
}


/* teachers */

*,
*::before,
*::after {
  box-sizing: border-box;
}


.btn {
  background-color: white;
  border: 1px solid #cccccc;
  //border-radius: 1rem;
  color: #696969;
  padding: 0.5rem;
  text-transform: lowercase;
}

.btn--block {
  display: block;
  width: 100%;
}

.cards {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
}

.cards__item {
  display: flex;
  padding: 0 1rem 1rem 1rem;
  @media (min-width: 40rem) {
    width: 50%;
  }
  @media (min-width: 56rem) {
    width: 25%;
  }
}

.card {
  background-color: white;
  border-radius: 0.25rem;
  box-shadow: 0 20px 40px -14px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &:hover {
    .card__image {
      filter: contrast(100%);
    }
  }
}

.card__content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  padding: 1rem;
}

.card__image {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  filter: contrast(70%);
  /* filter: saturate(180%); */
  overflow: hidden;
  position: relative;
  transition: filter 0.5s cubic-bezier(.43, .41, .22, .91);

  &::before {
    content: "";
    display: block;
    padding-top: 56.25%; /* 16:9 aspect ratio */
  }

  @media (min-width: 40rem) {
    &::before {
      padding-top: 66.6%; /* 3:2 aspect ratio */
    }
  }
}

.card__title {
  margin: 0 auto;
  padding-bottom: 20px;
  color: #696969;
  font-size: 1.25rem;
  font-weight: 300;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.card__text {
  flex: 1 1 auto;
  font-size: 0.875rem;
  line-height: 1.5;
  margin-bottom: 1.25rem;
}

/* recommendation */

.recommendation {
  margin-top: 100px;
}

.ei.segments.m-box {
  background-color: #ffffff;
  height: 350px;
}

.secondary.segment {
  padding: 10px;
  border-bottom: #fbbd08 2px solid;
}

.ei.divided.items {
  margin-top: 10px;
  display: flex;
  flex-wrap: nowrap; /* 使子元素横向排列 */
  overflow-x: auto; /* 横向滚动 */
}

.ei.divided.items .m-item:first-child {
  margin-left: 0;
}

.ei.divided.items .m-item {
  min-width: 24.3%; /* 设置一个最小宽度，可以根据需要调整 */
  margin-left: 1rem;
  height: 20rem;
  position: relative;
  overflow: hidden;
  border-radius: 5px;
  cursor: pointer;
  user-select: none;
}

.ei.divided.items .m-item .img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  object-fit: cover;
  background-position: center;
  background-size: cover;
}

.ei.divided.items .m-item .info {
  z-index: 1;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: .5rem !important;
  font-size: 12px;
  color: white;
}

.ei.divided.items .m-item .info .title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  word-break: break-word;
}

/* footer */

footer {
  width: 100%;
  height: 300px;
  background: gray;
  bottom: -300px;
  position: fixed;
  z-index: -2;
}

.foot {
  margin-top: 80px;
}

footer h1 {
  line-height: 300px;
}

.syd {
  width: 80px;
  float: left;
}

.w1200 {
  width: 100%;
  height: auto;
  margin: 0 auto;
  overflow: hidden;
}

.Foot {
  margin: 0 auto;
  padding: 30px 0 0 0;
  width: 460px;
  display: flex;
  align-items: center;
}

.Foot span {
  color: #ffffff;
  line-height: 27px;
  font-size: 14px;
  margin: 0;
  padding: 0;
}

.Foot a {
  color: rgb(255, 255, 255);
  text-decoration: none;
}

/* all */

img {
  height: auto;
  max-width: 100%;
  vertical-align: middle;
}


</style>
